<template>
  <div class="p-3">
    <!-- Detail view -->
    <div v-if="selectedGroupId">
      <course-group-detail :group-id="selectedGroupId" />
    </div>

    <!-- List view -->
    <div v-else>
      <div class="loading" v-if="fetchData">
        <load-data></load-data>
      </div>

      <div v-else class="col-8 mx-auto">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <!-- <h5 class="mb-0 font-weight-bold">
            <i class="fas fa-book text-success mr-2"></i> Courses &amp; Offerings
          </h5> -->
          <b-button variant="primary" size="sm" @click="openGenerateModal">
            <i class="fas fa-plus mr-1" style="font-size: 14px !important; vertical-align: middle;"></i>
            <span style="vertical-align: middle;">Generate Courses</span>
          </b-button>
        </div>

        <table class="table table-bordered table-striped">
          <thead class="thead-dark">
            <tr>
              <th style="width:50px">Sl.No</th>
              <th>Course Group Name</th>
              <th>Grouping Level</th>
              <th>Regulations/Scheme</th>
              <th>Created Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!courseGroups.length">
              <td colspan="6" class="text-center text-muted">No course groups found.</td>
            </tr>
            <tr v-for="(item, index) in courseGroups" :key="item.id">
              <td class="text-center">{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ capitalize(item.grouping_level) }}</td>
              <td>{{ item.filters ? item.filters.schemes : '—' }}</td>
              <td>{{ item.created_at ? formatDate(item.created_at) : '—' }}</td>
              <td>
                <b-button size="sm" variant="outline-primary" @click="selectedGroupId = item.id">
                  <i class="fas fa-eye mr-1"></i> View
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Generate Courses Modal -->
      <b-modal
        id="generateCourseModal"
        :title="generateModalTitle"
        hide-footer
        no-close-on-backdrop
        no-close-on-keyboard
        modal-class="usersListPendingFull"
        @hidden="resetForm"
      >
        <generate-course-modal
          ref="generateModal"
          @success="onGroupGenerated"
          @cancel="$bvModal.hide('generateCourseModal')"
          @title-change="generateModalTitle = $event"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import GenerateCourseModal from "./GenerateCourseModal.vue";
import CourseGroupDetail from "./CourseGroupDetail.vue";

export default {
  name: "CourseGroupsPage",

  components: { GenerateCourseModal, CourseGroupDetail },

  data() {
    return {
      fetchData: false,
      selectedGroupId: null,
      courseGroups: [],
      generateModalTitle: "Generate Courses",
    };
  },

  async mounted() {
    await this.fetchCourseGroups();
  },

  methods: {
    goBack() {
      if (this.selectedGroupId) {
        this.selectedGroupId = null;
        return true;
      }
      return false;
    },

    async fetchCourseGroups() {
      this.fetchData = true;
      try {
        const response = await this.$axios.get(
          `${this.$store.getters.getAPIKey.mainAPI}/course-groups`
        );
        this.courseGroups = response.data.data || [];
      } catch {
        this.$toasted.error("Failed to load course groups.", { duration: 3000 });
      } finally {
        this.fetchData = false;
      }
    },

    openGenerateModal() {
      this.$bvModal.show("generateCourseModal");
    },

    async onGroupGenerated() {
      this.$bvModal.hide("generateCourseModal");
      await this.fetchCourseGroups();
    },

    resetForm() {
      this.generateModalTitle = "Generate Courses";
      if (this.$refs.generateModal) {
        this.$refs.generateModal.resetForm();
      }
    },

    formatDate(dateStr) {
      const d = new Date(dateStr);
      if (isNaN(d)) return dateStr;
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },

    capitalize(str) {
      if (!str) return str;
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
  },
};
</script>

<style scoped>
.usersListPendingFull .modal-dialog {
  max-width: 100%;
  max-height: 100vh;
  margin: 0;
  padding: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  position: fixed !important;
  z-index: 100000;
}

.usersListPendingFull .modal-content {
  border-radius: 0 !important;
  height: 100vh;
  width: 100vw;
}

.usersListPendingFull .modal-body {
  overflow-y: auto;
  height: calc(100vh - 60px);
  /* header height */
}
</style>
